﻿import { useContext, useEffect } from 'react';
import useFilterGroup from '../../../../hooks/use-filter-group';
import useAllFilterGroups from '../../../../hooks/useAllFilterGroups';
import { FilterGroupType } from '../../../../types/filter-group';
import WorkspaceItemContext from '../../../contexts/workspace/workspace-item-context';
import { useAppSelector } from '../../../hooks/store-hooks';
import useMap from '../../../hooks/use-map';

export function NavDataProvider() {
    const workspace = useContext(WorkspaceItemContext);
    const map = useMap();
    const staticData = useAppSelector((state) => state.workspace.items[workspace.id].view.staticData);
    const terrainShading = useAppSelector((state) => state.workspace.items[workspace.id].view.map.terrainShading);
    const airportFilterGroups = useFilterGroup(FilterGroupType.airport);
    const navDataPlugin = useContext(WorkspaceItemContext).navDataPlugin;
    const allFilterGroups = useAllFilterGroups();
    const showLatLonGrid = useAppSelector((state) => state.workspace.items[workspace.id].view.staticData.latLon);
    const myAirports = useAppSelector((x) => x.global.flightWorker.myAirports);

    useEffect(() => {
        if (!map) {
            return;
        }

        if (showLatLonGrid.show) {
            navDataPlugin.showGrid();
        } else {
            navDataPlugin.hideGrid();
        }
    }, [map, showLatLonGrid]);

    useEffect(() => {
        if (!map || !staticData) {
            return;
        }

        navDataPlugin.applyNavDataFilter(staticData, allFilterGroups, myAirports);
        // FIXME: quick hack for now, fix by turning off/on runways properly not relying on queryFeatures.
        self.setTimeout(() => {
            navDataPlugin.setRunwaySettings(staticData.airport.settings);
        }, 100);
    }, [map, staticData, allFilterGroups, myAirports]);

    useEffect(() => {
        navDataPlugin.updateTerrainShading(terrainShading);
    }, [navDataPlugin, terrainShading]);

    // Update runway on move end
    useEffect(() => {
        if (!map) {
            return;
        }

        navDataPlugin.setRunwaySettings(staticData.airport.settings);
        return map.on('moveend', () => {
            navDataPlugin.updateRunwayDepiction(staticData.airport.settings);
        }).unsubscribe;
    }, [map, staticData.airport.settings]);

    // Update rings on move end
    useEffect(() => {
        if (!map) {
            return;
        }

        navDataPlugin.updateRangeRings(map, staticData.airport.settings);
        return map.on('moveend', () => {
            navDataPlugin.updateRangeRings(map, staticData.airport.settings);
        }).unsubscribe;
    }, [map, airportFilterGroups, staticData.airport, myAirports]);

    // Wait for the initial map load to render rings and runway (this is used when the map loads for the first time with a view that has runways or rings)
    useEffect(() => {
        const subscription = map?.on('idle', () => {
            navDataPlugin.updateRangeRings(map, staticData.airport.settings);
            navDataPlugin.setRunwaySettings(staticData.airport.settings);

            // Unsubscribe immediately to avoid infinite loops.
            // When you update a map source it will create a loop
            // Update runways source -> map fires 'idle' -> Update runways source -> map fires 'idle' ... (use moveend instead)
            subscription?.unsubscribe();
        });

        return subscription?.unsubscribe;
    }, [map]);

    return null;
}
